// Use Sigma picking/coordinates rather than DOM hit-testing. moveBody keeps a
// mouse drag alive outside the canvas; touch uses the same Sigma event path.
export function installNodeDrag(renderer, graph, getLayout) {
  const container = renderer.getContainer(), camera = renderer.getCamera();
  const mouse = renderer.getMouseCaptor(), touch = renderer.getTouchCaptor();
  let gesture = null, suppressUntil = 0;
  const suppressClick = () => Boolean(gesture?.moved) || performance.now() < suppressUntil;
  function finish(cancelled = false) {
    if (!gesture) return;
    if (gesture.moved) suppressUntil = performance.now() + 350;
    getLayout()?.endDrag(); gesture = null;
    container.classList.remove("is-node-dragging"); container.style.cursor = "default";
    // No stage inertia may survive a node gesture, including blur/cancel.
    mouse.isMoving = false; touch.isMoving = false;
    if (cancelled) { mouse.isMouseDown = false; touch.touchMode = 0; }
    camera.enable();
  }
  renderer.on("downNode", ({ node, event, preventSigmaDefault }) => {
    const original = event.original;
    if (("button" in original && original.button !== 0) || (original.touches && original.touches.length !== 1)) return;
    if (!getLayout()?.beginDrag(node)) return;
    suppressUntil = 0;
    const point = renderer.graphToViewport(graph.getNodeAttributes(node));
    gesture = { node, start: { x: event.x, y: event.y }, offset: { x: point.x - event.x, y: point.y - event.y }, moved: false };
    camera.disable(); preventSigmaDefault();
    container.classList.add("is-node-dragging");
  });
  renderer.on("moveBody", ({ event, preventSigmaDefault }) => {
    if (!gesture) return;
    if (event.original.touches?.length > 1) { finish(true); return; }
    // A missed button-up (e.g. released in another browser window) must not
    // leave a node grabbed on the next movement.
    if ("buttons" in event.original && event.original.buttons === 0) { finish(true); return; }
    preventSigmaDefault();
    if (event.original.cancelable) event.original.preventDefault();
    gesture.moved ||= Math.hypot(event.x - gesture.start.x, event.y - gesture.start.y) > 3;
    if (gesture.moved) getLayout()?.moveDragged(renderer.viewportToGraph({ x: event.x + gesture.offset.x, y: event.y + gesture.offset.y }));
  });
  mouse.on("mouseup", () => finish());
  touch.on("touchup", () => finish());
  touch.on("touchdown", event => { if (event.touches.length > 1) finish(); });
  renderer.on("doubleClickNode", payload => { if (suppressClick()) payload.preventSigmaDefault(); });
  renderer.on("doubleClickStage", payload => { if (suppressClick()) payload.preventSigmaDefault(); });
  renderer.on("enterNode", () => { if (!gesture) container.style.cursor = "grab"; });
  renderer.on("leaveNode", () => { if (!gesture) container.style.cursor = "default"; });
  graph.on("nodeDropped", ({ key }) => { if (gesture?.node === key) finish(true); });
  const cancel = () => finish(true);
  window.addEventListener("blur", cancel);
  container.addEventListener("touchcancel", cancel);
  renderer.on("kill", () => { cancel(); window.removeEventListener("blur", cancel); container.removeEventListener("touchcancel", cancel); });
  container.title = "Glisser un nœud pour le déplacer · Glisser le fond pour déplacer la vue";
  return { suppressClick, cancel };
}
